import React from "react";
import { Card } from "@mui/material";
import { Divider, Box, Grid, Typography } from "@mui/material";

export default function VendorContactCard(props) {
  return (
    <>
      {/* <Box border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec"
        className="mt-3"
        sx={{ width: "auto", padding: "10px", height: "147px" }}
        key={props?.contacts?.groupNumber}
      >
        <h6
          className="card-title "
          style={{
            marginBottom: 10,
            color: "#667085",
            fontSize: "17px", 
            fontWeight: "bold"
          }}
        >
          {props?.contacts?.fullName}
        </h6>
        <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
        <h6
          className="card-subtitle"
          style={{
            fontSize: "15px",
            fontWeight: "400",
            color: "#101828",
            marginBottom: 5,
            marginTop: 10,
          }}
        >
          {props?.contacts?.title}
        </h6>
        <h6
          style={{
            fontSize: "15px",
            color: "#007acc",
            marginBottom: 5,
            fontWeight: "400",
          }}
        >
          {props?.contacts?.emailAddress}
        </h6>
        <h6
          style={{
            fontSize: "15px",
            color: "#007acc",
            marginBottom: 5,
            fontWeight: "400",
          }}
        >
          {props?.contacts?.telephoneNumber}
        </h6>
      </Box> */}


      <Box
        border={1}
        borderLeft={1}
        borderRight={1}
        borderColor="#e4e7ec"
        className="mt-3"
        sx={{
          width: "100%",
          height: "100%",
          minHeight: "147px",
          padding: "10px",
          boxSizing: "border-box",
          backgroundColor: "#fff",
        }}
      >
        {/* Full Name */}
        <h6
          className="card-title"
          style={{
            marginTop: 0,
            marginBottom: 5,
            color: "#667085",
            fontSize: "17px",
            fontWeight: "bold",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
          }}
        >
          {props?.contacts?.fullName}
        </h6>

        {/* Divider */}
        <Divider
          sx={{
            marginTop: 2,
            marginBottom: 2,
            backgroundColor: "#667085",
            height: "2px",
          }}
        />

        {/* Title */}
        <h6
          className="card-subtitle"
          style={{
            fontSize: "15px",
            fontWeight: "400",
            color: "#101828",
            marginTop: 0,
            marginBottom: 5,
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
          }}
        >
          {props?.contacts?.title}
        </h6>

        {/* Email */}
        <h6
          style={{
            fontSize: "15px",
            color: "#007acc",
            marginTop: 0,
            marginBottom: 5,
            fontWeight: "400",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
          }}
        >
          {props?.contacts?.emailAddress}
        </h6>

        {/* Telephone */}
        <h6
          style={{
            fontSize: "15px",
            color: "#007acc",
            marginTop: 0,
            marginBottom: 3,
            fontWeight: "400",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
          }}
        >
          {props?.contacts?.telephoneNumber}
        </h6>
      </Box>

    </>
  );
}
